import vue from '.././main.js';
import axios from 'axios'
import { getToken, delToken } from '@/utils/user.js'
import { getLang } from '@/utils/config.js'

const service = axios.create({
  //正式用这个
  baseURL: window.location.origin+'/project/afc_api/index.php',

  //本地测试用这个
  //baseURL: '/host/afc_api/index.php',
  timeout: 30000
})

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['token'] = vue.$store.getters['user/getToken'] || getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers['lang'] = vue.$store.state.config.lang || getLang()
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.code !== 2000) {
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 5001) {
        delToken();
        vue.$swal({
          title: vue.$i18n.t('MessageBox.Api.Request.Relogin'),
          type: 'warning',
          timer: 2000,
          showConfirmButton: true,
          confirmButtonText: vue.$i18n.t('MessageBox.Button.Confirm'),
          onClose(){
            vue.$router.push({path: '/login'});
          }
        });
        return Promise.reject('error')
      }
      vue.$swal({
        title: vue.$i18n.t('MessageBox.Api.Request.ErrorMsg')+res.msg,
        type: 'error',
        timer: 3000,
        showConfirmButton: true,
      });
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    console.log('网络错误：' + error) // for debug
    vue.$swal({
      title: vue.$i18n.t('MessageBox.Api.Request.NetworkError')+error.msg,
      type: 'error',
      timer: 3000,
      showConfirmButton: true,
    });
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js